import React from 'react';
import '../styles/DesyncPromo.scss';

const DesyncPromo = () => {
  return (
    <section className="desync-promo">
      <div className="desync-promo__container">
        <div className="desync-promo__panel">
          <div className="desync-promo__content">
            <span className="desync-promo__eyebrow">Digital Experience Partner</span>
            <p className="desync-promo__title">Website design, upkeep, and growth support by Desync.</p>
            {/* <p className="desync-promo__text">The footer credit is now a fuller promotional block with a clearer visual hierarchy and direct destination.</p> */}
          </div>
          <div className="desync-promo__actions">
            <span className="desync-promo__url">www.desync.in</span>
            <a 
              href="https://www.desync.in" 
              target="_blank" 
              rel="noopener noreferrer"
              className="desync-promo__link"
            >
              Visit Desync
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesyncPromo;
